import React, {createRef, useEffect, useState} from 'react';
import Alert from "@mui/material/Alert";

export default function Hidden(props) {

    const inputRef = createRef();

    const data = props.data;
    const updateFormData = props.updateFormData;

    const [hiddenValue, setHiddenValue] = useState(data.value);

    useEffect(() => {

        if(hiddenValue !== data.value){

            setHiddenValue(data.value);

        }

    }, [props]);

    return <div id={data.id} className="sendiio-form-hidden-element isHidden">
        <input ref={inputRef}
               className="sendiio-form-hidden-input cursor-text"
               type="text"
               onChange={e => {

                   setHiddenValue(e.currentTarget.value);

               }}
               placeholder="Enter your value here"
               id={`input-${data.id}-hidden`}
               name={`${data.id}-hidden`}
               value={hiddenValue}
               onBlur={e => {

                   if(hiddenValue !== e.currentTarget.textContent) {

                       //console.log('UPDATE DATA!!!', e.currentTarget);

                       data.value = hiddenValue;

                       updateFormData(data);

                       inputRef.current.textContent = hiddenValue;

                   }

               }} />
        <Alert className="mt-12 px-12 py-0" severity="warning"><small>This field is hidden and will not be seen on the form.</small></Alert>
    </div>

}